import { Helmet } from "react-helmet-async";
import { absoluteUrl, serializeJsonLd } from "../utils/siteUrl";

type SeoProps = {
  title: string;
  description: string;
  path?: string;
  image?: string;
  jsonLd?: Record<string, unknown>;
  noindex?: boolean;
};

export function Seo({ title, description, path = "/", image = "/bezkin-logo.jpeg", jsonLd, noindex = false }: SeoProps) {
  const canonical = absoluteUrl(path);
  const imageUrl = absoluteUrl(image);
  const googleVerification = import.meta.env.VITE_GOOGLE_SITE_VERIFICATION?.trim();
  const bingVerification = import.meta.env.VITE_BING_SITE_VERIFICATION?.trim();

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {googleVerification ? <meta name="google-site-verification" content={googleVerification} /> : null}
      {bingVerification ? <meta name="msvalidate.01" content={bingVerification} /> : null}
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow, max-image-preview:large"} />
      {!noindex ? <link rel="canonical" href={canonical} /> : null}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content={title} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      {jsonLd ? <script type="application/ld+json">{serializeJsonLd(jsonLd)}</script> : null}
    </Helmet>
  );
}
